import BottomSheet from 'components/BottomSheet';
import Icon from 'components/Icon';
import React from 'react';
import Form from './Form';

type AppProps = {
  open: boolean;
  closeModal: () => any;
  productId?: string;
  initial?: Record<string, any>;
  onSuccess?: (...args: any) => any;
  prefix?: string;
};

const CreateProduct: React.FC<AppProps> = ({
  open,
  closeModal,
  productId = '',
  initial = {},
  onSuccess = () => null,
  prefix = '',
}) => {
  return (
    <BottomSheet open={open} maxWidth="max-w-3xl">
      <div className="pb-4">
        <div className="flex justify-between">
          <div className="page-heading">
            {productId ? 'Edit Product' : 'Create Product'}
          </div>
          <div>
            <Icon
              name="close"
              size={32}
              onClick={closeModal}
              className="cursor-pointer"
            />
          </div>
        </div>
      </div>
      <Form
        productId={productId}
        onSuccess={(res) => {
          onSuccess?.(res);
          closeModal();
        }}
        initial={initial}
        prefix={prefix}
      />
    </BottomSheet>
  );
};

export default CreateProduct;
